import { graphConfig, loginRequest, msalInstance } from '../config/msalConfig';
import type { GraphData } from '@/types';
import { hasAuthTokens } from './authToken';

export async function callMsGraph(
  accessToken?: string,
): Promise<[GraphData, Blob | null, boolean]> {
  if (hasAuthTokens()) {
    const stub: GraphData = {
      displayName: 'Auth Token User',
      mail: 'auth-token@local',
      userPrincipalName: 'auth-token@local',
    } as GraphData;
    return [stub, null, false];
  }

  if (!accessToken) {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      throw Error(
        'No active account! Verify a user has been signed in and setActiveAccount has been called.',
      );
    }

    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    accessToken = response.accessToken;
  }

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers,
  };

  const graphDataPromise = fetch(graphConfig.graphMeEndpoint, options).then((response) =>
    response.json(),
  );

  const photoPromise = fetch(graphConfig.graphUserPhotoEndpoint, options).then(async (response) => {
    if (!response.ok) {
      return { blob: null as Blob | null, hasPhoto: false };
    }
    const contentType = response.headers.get('content-type') ?? '';
    if (!contentType.startsWith('image/')) {
      return { blob: null as Blob | null, hasPhoto: false };
    }
    try {
      const blob = await response.blob();
      return { blob, hasPhoto: true };
    } catch {
      return { blob: null as Blob | null, hasPhoto: false };
    }
  });

  const [graphData, { blob, hasPhoto }] = await Promise.all([graphDataPromise, photoPromise]);
  return [graphData, blob, hasPhoto];
}
